import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../../Styles/AttendanceDetails.css";
import Loader from "../../Components/Loader";

function AttendanceDetails() {
  const { userId } = useParams();
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAttendanceData = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          setError("No authentication token found.");
          return;
        }

        const response = await axios.get(
          `https://api.uniums.com/api/admin/faculty-attendance/${userId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setAttendanceData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching attendance data:", error);
        setError("Error fetching attendance data.");
      } finally {
        setLoading(false);
      }
    };

    fetchAttendanceData();
  }, [userId]);

  const generateCalendar = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const attendanceMap = {};
    attendanceData.forEach((record) => {
      const date = new Date(record.date);
      const dateString = date.toLocaleDateString();
      attendanceMap[dateString] = record; 
    });

    const getDayStatus = (day, month) => {
      const date = new Date(2025, month, day); 
      const dateString = date.toLocaleDateString();
      return attendanceMap[dateString] || null; 
    };

    return months.map((month, monthIndex) => {
      const year = 2025; // Using current year
      const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
      const firstDay = new Date(year, monthIndex, 1).getDay(); // Get the first day of the month (0 = Sunday, 1 = Monday, etc.)
      
      // Create array for weeks
      const weeks = [];
      let currentWeek = [];
      
      // Add empty cells for days before the first day of the month
      for (let i = 0; i < firstDay; i++) {
        currentWeek.push(<td key={`empty-${i}`} className="empty-day"></td>);
      }
      
      // Add days of the month
      for (let day = 1; day <= daysInMonth; day++) {
        const dayData = getDayStatus(day, monthIndex);
        let statusContent = "No Data";
        let classNames = "no-data";

        if (dayData) {
          statusContent = dayData.status === "Present" ? "Present" : "Absent";
          classNames = dayData.status === "Present" ? "present" : "absent";
        }

        currentWeek.push(
          <td key={day} className={classNames}>
            {day}
            <br />
            {statusContent}
            {dayData && dayData.status === "Present" && (
              <div>
                <strong>Classes:</strong> {dayData.classes.join(", ")}
                <br />
                <strong>Subjects:</strong> {dayData.subjects.join(", ")}
                <br />
                <strong>Time:</strong>{" "}
                {new Date(dayData.timestamp).toLocaleTimeString()}
              </div>
            )}
          </td>
        );

        // If we've reached the end of a week or the end of the month, start a new week
        if ((firstDay + day) % 7 === 0 || day === daysInMonth) {
          weeks.push(<tr key={`week-${weeks.length}`}>{currentWeek}</tr>);
          currentWeek = [];
        }
      }

      return (
        <div key={month}>
          <h3>{month}</h3>
          <div className="attendance-table-legend">
            <table border="1" className="attendance-table-attendance">
              <thead>
                <tr>
                  <th>Sun</th>
                  <th>Mon</th>
                  <th>Tue</th>
                  <th>Wed</th>
                  <th>Thu</th>
                  <th>Fri</th>
                  <th>Sat</th>
                </tr>
              </thead>
              <tbody>{weeks}</tbody>
            </table>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="attendance-month">
      <h1>Attendance History Of {new Date().getFullYear()}</h1>
      {loading ? (
        <Loader />
      ) : error ? (
        <p>{error}</p>
      ) : (
        <div>{generateCalendar()}</div>
      )}
    </div>
  );
}

export default AttendanceDetails;